module.exports = __webpack_public_path__ + "img/capitano 1.fbbbe4d7.jpeg";